import Map from '../../components/Map/Map'
import CaseLayout from '../../layouts/CaseLayout/CaseLayout'
import DashActions from '../../components/dashboard/DashActions/DashActions'
import DashScene from '../../components/dashboard/DashScene/DashScene'
import Chapter from '../../components/Chapter/Chapter'

const Dashboard = () => {
  return (
    <CaseLayout>
      <Map />
      <Chapter />
      <DashActions />
      <DashScene />
    </CaseLayout>
  )
}

export default Dashboard
